import salvattore from 'salvattore/dist/salvattore';
import {WOW} from 'wowjs/dist/wow';

export default {
  init() {
    this._page = 1;
    this._skipload = true;
    this.$win = $(window);
    this.$doc = $(document);
    this.getTumblr(this._page);
  },
  finalize() {
  },
  getTumblr() {
    var that = this;
    console.log(window.woocommerce_params.ajax_url);
    $.ajax({
        url : window.woocommerce_params.ajax_url, type : 'post',
        data : {
            action : 'inspirations',
            pager : that._page,
        },
        success : function( response ) {
            that.onTumblr(response);
        },

    });

  },
  onTumblr(data) {

    console.log(data);

      var grid = document.querySelector('#grid');
      var posts = data.response.posts;
      var items = [];

      $.each(posts, function(i, item) {
          console.log(item);
          var m = (i % 4)*.2;
          if (item.photos) {
            var $img = $(document.createElement('img'))
                  .addClass('img-responsive')
                  .attr('src', item.photos[0].alt_sizes[0].url)
                  .data('wow-delay', m);

            var $div = $(document.createElement('div'))
                .addClass('wow fadeInUp item')
                .append($img);
                // .appendTo('.masonry');

            items.push($div[0]);

          }
      });

      var wow = new WOW({
          offset:10,
      });
      wow.init();

      console.log(items);
      if (this._skipload) {
          this._page = 1;
          this.$win.on('scroll', $.proxy(this._onInspiScroll, this));
          this._skipload = false;
      }
      salvattore.appendElements(grid, items);
      this._wait = false;
      wow.sync();
  },
  _onInspiScroll() {
      if(this.$win.scrollTop() + this.$win.height() > this.$doc.height() - 300) {
          if (!this._wait) {
              $('.item').show();
              this._wait = true;
              this.getTumblr(this._page++);
          }

      }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/inspirations.js